import React from 'react'
import { SvgGraphic, SvgGraphicProps } from '../../design-system'

export const JumpArrowGraphic = (props: SvgGraphicProps) => (
  <SvgGraphic viewBox="0 0 81 21" fill="none" {...props}>
    <path
      d="M0 10.31h77.59"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeMiterlimit={10}
    />
    <path
      d="M63.18 20.13a1 1 0 0 1 .31-1.41l13.61-8.4L63.5 1.9c-.24-.15-.4-.38-.47-.64a1 1 0 0 1 .15-.77 1.04 1.04 0 0 1 .66-.45 1.09 1.09 0 0 1 .8.13l15 9.27a1.04 1.04 0 0 1 .47.86 1 1 0 0 1-.48.86l-15 9.27a1.08 1.08 0 0 1-1.45-.32z"
      fill="currentColor"
    />
  </SvgGraphic>
)
